<template>
  <transition name="service-time-dialog-fade">
    <div v-if="visible" class="service-time-dialog" @click.self="handleClose">
      <div class="panel">
        <button type="button" class="close" aria-label="关闭客服工作时间弹窗" @click="handleClose">
          <img src="../../../assets/home-confirm/dialogs/service-close.svg" alt="" class="close-icon" />
        </button>

        <p class="title">客服工作时间</p>

        <div class="work-row">
          <img src="../../../assets/home-confirm/dialogs/service-time.png" alt="客服" class="work-image" />
          <p class="work-text">{{ serviceTimeText }}</p>
        </div>

        <div class="phone-box">
          <p class="phone-text">客服官方手机号：{{ kefuPhoneText }}（微信同步）</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ServiceTimeDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    serviceTime: {
      type: String,
      default: "",
    },
    kefuPhone: {
      type: String,
      default: "",
    },
  },
  computed: {
    serviceTimeText() {
      return this.serviceTime || "工作日：8：00-20：00";
    },
    kefuPhoneText() {
      return this.kefuPhone || "18804271129";
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.service-time-dialog {
  position: fixed;
  inset: 0;
  z-index: 1993;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  background: rgba(0, 0, 0, 0.5);
}

.panel {
  position: relative;
  box-sizing: border-box;
  width: 380px;
  height: 271px;
  padding: 15px 17px 42px;
  background: #ffffff;
  box-shadow: 0 22px 48px rgba(0, 0, 0, 0.24);
}

.close {
  position: absolute;
  top: 15px;
  right: 17px;
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
}

.close-icon {
  width: 14px;
  height: 14px;
}

.title {
  margin: 22px 0 0;
  color: #000000;
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  text-align: center;
}

.work-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 13px;
  padding: 0 42px 0 32px;
}

.work-image {
  width: 96px;
  height: 96px;
}

.work-text {
  margin: 0;
  color: #000000;
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
}

.phone-box {
  display: flex;
  align-items: center;
  margin-top: 16px;
  border-radius: 10px;
  padding: 14px 13px 15px;
  background: #d92f24;
}

.phone-text {
  margin: 0;
  width: 100%;
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  white-space: nowrap;
}

.service-time-dialog-fade-enter-active,
.service-time-dialog-fade-leave-active {
  transition: opacity 0.2s ease;
}

.service-time-dialog-fade-enter-active .panel,
.service-time-dialog-fade-leave-active .panel {
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.service-time-dialog-fade-enter,
.service-time-dialog-fade-leave-to {
  opacity: 0;
}

.service-time-dialog-fade-enter .panel,
.service-time-dialog-fade-leave-to .panel {
  opacity: 0;
  transform: translateY(12px) scale(0.98);
}
</style>
